import type { ThemeConfig } from 'antd'
import { theme as antdTheme } from 'antd'
import PALLETTE from './pallette.module.scss'
import { THEME_ID } from '../redux/appSlice'

const controlHeight = 50

const darkInputBg = '#282828'
const darkInputText = '#ffffff'
const darkPlaceholder = 'rgba(255,255,255,0.5)'

const lightInputBg = '#ffffff'
const lightInputText = '#111111'
const lightPlaceholder = 'rgba(0,0,0,0.45)'

const commonComponents: ThemeConfig['components'] = {
  Button: {
    controlHeight,
    colorTextLightSolid: '#000000',
  },
  Form: {
    verticalLabelPadding: '0 0 2px',
  },
}

export const darkTheme: ThemeConfig = {
  algorithm: antdTheme.darkAlgorithm,
  token: {
    controlHeight: 40,
    fontSize: 16,
    borderRadius: 8,
    fontFamily: 'Roboto',
    colorPrimary: PALLETTE.primaryColor,
    colorTextBase: '#ffffff',
    colorText: '#ffffff',
    colorLink: PALLETTE.primaryColor,
    colorBgBase: '#030303',
    colorBgContainer: '#111111',
  },
  components: {
    ...commonComponents,
    Layout: { headerColor: '#ffffff' },
    Select: {
      controlHeight,
      colorBgContainer: darkInputBg,
      colorText: darkInputText,
      colorTextPlaceholder: darkPlaceholder,
      colorBorder: darkInputBg,
    },
    // Typography: {
    //   colorText: '#ffffff',
    // },
    DatePicker: {
      controlHeight,
      colorBgContainer: darkInputBg,
      colorText: darkInputText,
      colorTextPlaceholder: darkPlaceholder,
      colorBorder: darkInputBg,
    },
    Input: {
      controlHeight,
      colorBgContainer: darkInputBg,
      colorText: darkInputText,
      colorTextPlaceholder: darkPlaceholder,
      colorBorder: darkInputBg,
    },
    InputNumber: {
      controlHeight,
      colorBgContainer: darkInputBg,
      colorText: darkInputText,
      colorTextPlaceholder: darkPlaceholder,
      colorBorder: darkInputBg,
    },
  },
}

export const lightTheme: ThemeConfig = {
  algorithm: antdTheme.defaultAlgorithm,
  token: {
    controlHeight: 40,
    fontSize: 16,
    borderRadius: 8,
    fontFamily: 'Roboto',
    colorPrimary: PALLETTE.primaryColor,
    colorTextBase: '#0f172a',
    colorText: '#0f172a',
    colorLink: PALLETTE.primaryColor,
    colorBgBase: '#f5f7fb',
    colorBgContainer: '#ffffff',
  },
  components: {
    ...commonComponents,
    Layout: { headerColor: '#0f172a' },
    // Typography: {
    //   colorText: '#0f172a',
    // },
    Select: {
      controlHeight,
      colorBgContainer: lightInputBg,
      colorText: lightInputText,
      colorTextPlaceholder: lightPlaceholder,
      colorBorder: 'rgba(15,23,42,0.15)',
    },
    DatePicker: {
      controlHeight,
      colorBgContainer: lightInputBg,
      colorText: lightInputText,
      colorTextPlaceholder: lightPlaceholder,
      colorBorder: 'rgba(15,23,42,0.15)',
    },
    Input: {
      controlHeight,
      colorBgContainer: lightInputBg,
      colorText: lightInputText,
      colorTextPlaceholder: lightPlaceholder,
      colorBorder: 'rgba(15,23,42,0.15)',
    },
    InputNumber: {
      controlHeight,
      colorBgContainer: lightInputBg,
      colorText: lightInputText,
      colorTextPlaceholder: lightPlaceholder,
      colorBorder: 'rgba(15,23,42,0.15)',
    },
  },
}

export function resolveThemeMode(
  themeId: THEME_ID,
  systemDark: boolean,
): 'dark' | 'light' {
  if (themeId === THEME_ID.DARK) return 'dark'
  if (themeId === THEME_ID.LIGHT) return 'light'
  return systemDark ? 'dark' : 'light'
}

export function getAntdTheme(themeId: THEME_ID, systemDark = false): ThemeConfig {
  const mode = resolveThemeMode(themeId, systemDark)
  return mode === 'dark' ? darkTheme : lightTheme
}

/**
 * Чтобы не падал старый импорт:
 * import { defaultTheme } from './utils/theme/antdThemeConfig'
 */
export const defaultTheme = darkTheme
